<template>
  <div>
  </div>
</template>

<script>
  export default {
    created () {
      if (this.$auth.user().visualizacao === 'mapa') {
        this.$router.push({ name: 'ImoveisMapa' })
      } else {
        this.$router.push({ name: 'ImoveisLista' })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ImoveisRoot.vue?4f5afe87